import {makeReactContext} from 'lib/makeReactContext';
import {PaneBorder} from 'ui-library/pane/Pane';
import {TabLayoutBackgroundColor} from 'ui-library/TabLayout';

import {DEFAULT_DASHBOARD_VIEW_STATE_ID} from './view-state/AnalyticsDashboardViewState';

export interface AnalyticsDashboardTheme {
  dashboardBackgroundColor: TabLayoutBackgroundColor;
  paneBorder: PaneBorder;
}

export interface AnalyticsDashboardContextOutput {
  analyticsDashboardViewStateId: string;
  // If true, expensive components should not be rendered immediately to allow other elements of the
  // browser screen to render with higher priority.
  // This is originally added to prevent loading delay when opening entities with embedded dashboards
  // that are expensive to render - setting this to true allows the entity tab to open immediately
  // rather than after the dashboard has rendered.
  delayExpensiveRenders: boolean;
  showReadOnlyBadge: boolean;
  showDashboardCloneButton: boolean;
  showDashboardLink: boolean;
  theme: AnalyticsDashboardTheme;
}

export const DEFAULT_DASHBOARD_DETAILS_CONTEXT: AnalyticsDashboardContextOutput = {
  analyticsDashboardViewStateId: DEFAULT_DASHBOARD_VIEW_STATE_ID,
  delayExpensiveRenders: false,
  showReadOnlyBadge: true,
  showDashboardCloneButton: true,
  showDashboardLink: false,
  theme: {
    dashboardBackgroundColor: TabLayoutBackgroundColor.GRAY_LIGHTER,
    paneBorder: PaneBorder.BOX_SHADOW,
  },
};

const AnalyticsDashboardDetailsContext = makeReactContext<AnalyticsDashboardContextOutput>(
  () => DEFAULT_DASHBOARD_DETAILS_CONTEXT,
  'AnalyticsDashboardDetailsContext'
);

export function useAnalyticsDashboardContext(): AnalyticsDashboardContextOutput {
  return AnalyticsDashboardDetailsContext.useContext();
}

export default AnalyticsDashboardDetailsContext;
